module.exports = __webpack_public_path__ + "img/74.30ee6ae2.png";